__turbopack_context__.v({
  "action": "AiGeneratedTeamProfileBanner-module-scss-module__TCQdwW__action",
  "icon": "AiGeneratedTeamProfileBanner-module-scss-module__TCQdwW__icon",
  "message": "AiGeneratedTeamProfileBanner-module-scss-module__TCQdwW__message",
  "root": "AiGeneratedTeamProfileBanner-module-scss-module__TCQdwW__root",
});
